import { Link } from 'react-router-dom';
import { LinkButtonTypes } from './types';

import './link-button.css';

export default function LinkButton({
  className = '',
  text = '',
  disabled,
  icon,
  path,
  onClick,
  backPath,
  target,
}: LinkButtonTypes): React.JSX.Element {
  return (
    <Link
      to={path}
      state={backPath || ''}
      className={`link-button ${className} ${disabled ? 'disabled' : ''}`}
      onClick={onClick}
      target={target}
    >
      {Boolean(icon) && (
        <span className={`icon-wrapper ${!text ? 'no-spaces' : ''}`}>
          {icon}
        </span>
      )}
      {Boolean(text) && (
        <span className={`text ${icon ? 'with-icon' : ''}`}>{text}</span>
      )}
    </Link>
  );
}
